import React from 'react';
import { Navigate } from 'react-router-dom';
import { isSignedIn } from 'library/auth';
import { PORTAL_ROUTES } from 'utils/constants';

interface PublicRouteProps {
  element: React.ReactElement;
}

export const PublicRoute = ({ element }: PublicRouteProps) => {
  if (isSignedIn()) {
    return <Navigate to={PORTAL_ROUTES.DASHBOARD} replace />;
  }

  return element;
};
